type ScoringEventType = 'IN_TIME_RESPONSE_EVENT' | 'REVIEW_EVENT';

export type ScoringEvent = {
  id: string;
  type: ScoringEventType;
  points: number;
  conversationId: string | null;
  hostScoreId: string;
  accountId: string;
  createdAt: Date;
  updatedAt: Date;
}

export type HostScore = {
  id: string;
  type: ScoringEventType;
  accountId: string;
  cappedScore: number;
  totalScore: number;
  createdAt: Date;
  updatedAt: Date;
  level: number;
}

// Level Thresholds
const LEVEL_0_LABEL = 'Basic';
const LEVEL_1_LABEL = 'Bronze';
const LEVEL_2_LABEL = 'Silver';
const LEVEL_3_LABEL = 'GOLD';

export const getHostMetricsLevelLabelAndIcon = (level: number) => {
  switch (level) {
    case 0:
      return {label: LEVEL_0_LABEL, icon: undefined}
    case 1:
      return {label: LEVEL_1_LABEL, icon: '🥉'}
    case 2:
      return {label: LEVEL_2_LABEL, icon: '🥈'}
    case 3:
      return {label: LEVEL_3_LABEL, icon: '🥇'}
    default:
      console.error(`Unknown score level: ${level}`);
      return {label: level, icon: undefined}
  }
}

export const getHostScoringTypeLabel = (type: ScoringEventType) => {
  switch (type) {
    case 'IN_TIME_RESPONSE_EVENT':
      return 'Timely Response';
    case 'REVIEW_EVENT':
      return 'Review';
    default:
      console.error(`Unknown ScoringEventType: ${type}`);
      return type;
  }
}

